import { usageTracker, UsageTrackerEvent } from "@volumental/analytic";
import { Button, CommentBox, Content } from "@volumental/common";
import { useState } from "react";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../components/modal/modal";

interface CommentFeedbackModalProps {
  onClose: (feedback: boolean) => void;
  show: boolean;
  scanID?: string;
  previousPurchaseID?: string;
}

export function CommentFeedbackModal({
  onClose,
  show,
  scanID,
  previousPurchaseID,
}: CommentFeedbackModalProps): JSX.Element {
  const { t } = useTranslation();
  const [comment, setComment] = useState("");
  const onSubmit = (): void => {
    usageTracker.track(UsageTrackerEvent.SizeChartComment, {
      comment,
      scanID,
      previous_purchase_id: previousPurchaseID,
    });

    onClose(true);
  };
  const onSkip = (): void => {
    onClose(false);
  };
  return (
    <Modal show={show} close={onSkip} modalTitle={t("feedbackModal.commentTitle")}>
      <Content disableGutters disableScrollbar>
        <span className="text-base">{t("feedbackModal.commentTitle")}</span>
        <div className="py-4">
          <CommentBox
            ariaLabel={t("ariaLabels.commentBox")}
            onWritingComment={setComment}
            placeHolderText={t("feedbackModal.commentPlaceHolder")}
          />
        </div>
      </Content>
      <Button onClick={onSubmit} disabled={comment === ""}>
        {t("button.submit")}
      </Button>
    </Modal>
  );
}
